export enum IntentCRMExportEnum {
    HUBSPOT = 'HubSpot',
    ZOHO = 'Zoho',
    DYNAMICS = 'Dynamics',
    SALESFORCE = 'Salesforce',
}